export default __webpack_public_path__ + "static/media/hero.c6b5cf28.png";